import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { API } from "../api";

export const taskQueryOptions = (taskId: string) =>
  queryOptions({
    queryKey: ["task", taskId],
    queryFn: async () => {
      const response =
        await API.personalNotes.personalNotesControllerFindOne(taskId);
      return response.data;
    },
  });

export const useTask = (taskId: string) => {
  return useQuery(taskQueryOptions(taskId));
};

export const useTaskSuspense = (taskId: string) => {
  return useSuspenseQuery(taskQueryOptions(taskId));
};
